<template>
    <ul class="legend-price is-flex">
        <template v-for="(item, index) in legend">
            <li class="legend-price__item is-flex" v-bind:key="index"
                v-if="item.freePlaceQuantity > 0">
                <div class="legend-price__item__color" :style="`background-color: ${item.color};`"></div>
                <div class="legend-price__item__price is-size-7">{{item.price}} руб.</div>
            </li>
        </template>
    </ul>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "LegendPrice",
        computed: {
            ...mapState({
                hallPlan: state => state.hallPlan,
            }),
            legend() {
                let legend = [];
                if (this.hallPlan.length > 0) {
                    let section = this.hallPlan.find(i => i.sectorId === parseInt(this.$route.params.section_id));
                    if (section && section.legendTariffs) {
                        legend = section.legendTariffs;
                    }
                }

                return legend;
            },
        },
    }
</script>

<style scoped>

</style>
